// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wj2El{display:flex;flex-direction:row;align-items:center;gap:16px;padding:16px 0}.XD0Gd{flex-direction:column;align-items:flex-start;gap:4px}.Ax4og{flex:0 0 150px}.IMuc4{flex:1;min-width:0;display:flex;align-items:center;gap:8px}.lW5GU{padding:0 24px}.lW5GU.tV0rc{padding:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `wj2El`,
	"rowMobile": `XD0Gd`,
	"label": `Ax4og`,
	"value": `IMuc4`,
	"section": `lW5GU`,
	"sectionMobile": `tV0rc`
};
export default ___CSS_LOADER_EXPORT___;
